import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface FilterItem {
  id: string;
  label?: string;
  control: ReactNode;
}

interface FilterBarProps {
  search?: {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    loading?: boolean;
  };
  filters?: FilterItem[];
  onClear?: () => void;
  activeCount?: number;
  rightActions?: ReactNode;
  className?: string;
}

export function FilterBar({ search, filters, onClear, activeCount = 0, rightActions, className }: FilterBarProps) {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {search ? (
        <div className="relative w-full sm:w-80 lg:w-[360px]">
          <i className="ri-search-line pointer-events-none absolute inset-y-0 left-0 flex w-9 items-center justify-center text-base text-foreground-400" />
          <input
            value={search.value}
            onChange={(e) => search.onChange(e.target.value)}
            placeholder={search.placeholder ?? "Search…"}
            className="h-9 w-full rounded-md border border-background-300 bg-background-50 pl-9 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400/40"
          />
          {search.loading ? (
            <span className="pointer-events-none absolute inset-y-0 right-0 flex w-8 items-center justify-center text-primary-600">
              <i className="ri-loader-4-line animate-spin text-base" />
            </span>
          ) : search.value ? (
            <button
              type="button"
              aria-label="Clear search"
              onClick={() => search.onChange("")}
              className="absolute inset-y-0 right-0 flex w-8 cursor-pointer items-center justify-center text-foreground-400 hover:text-foreground-700"
            >
              <i className="ri-close-line text-base" />
            </button>
          ) : null}
        </div>
      ) : null}
      {filters?.map((f) => <div key={f.id} className="flex flex-none items-center gap-1.5">{f.control}</div>)}
      {activeCount > 0 && onClear ? (
        <button type="button" onClick={onClear} className="cursor-pointer text-xs font-medium text-primary-600 hover:underline">
          Clear filters ({activeCount})
        </button>
      ) : null}
      {rightActions ? <div className="ml-auto flex flex-none flex-wrap items-center gap-2">{rightActions}</div> : null}
    </div>
  );
}